import {URL_BASE} from "../../../../../Globals.ts";
import {getIdToken} from "../../../../misc/miscUtils.ts";

export const clearEmbeddingsTracker = async (user: any, projectName: string) => {
    if (!user) return;

    const token = await getIdToken(user);

    try {
        const url = `${URL_BASE}/api/clearEmbeddingsTracker`;

        await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
            body: JSON.stringify({ projectName })
        });
    } catch (error) {
        console.error(`Error clearing embeddings tracker: ${error}`);
    }
};
